import { ChangeEventHandler,useState } from 'react';

import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import {
    Box,
    IconButton,
    TextField,
    TextFieldProps
} from '@mui/material';
import { createTheme } from '@mui/material/styles';
import createStyled from '@mui/system/createStyled';

import { TextAreaPopout, TextAreaPopoutProps } from './components/TextAreaPopout';

const defaultTheme = createTheme({});
const styled = createStyled({ defaultTheme });

const ExpandableTextField = styled(TextField)<TextFieldProps>(
    () => ({
        '& .MuiFilledInput-root': {
            paddingBottom: '35px'
        }
    })
);

export type ExpandableTextAreaCommonProps = {
  value: string,
  onChange: (value: string) => void,
  disabled?: boolean,
  placeholder?: string,
  label?: string,
};

export type ExpandableTextAreaProps = {
    textAreaCommonProps: ExpandableTextAreaCommonProps,
    popoutCommonProps: Pick<TextAreaPopoutProps, 'popoutInputBaseProps' | 'popoutInputLabel'>
};

export function ExpandableTextArea({
    textAreaCommonProps,
    popoutCommonProps,
}: Readonly<ExpandableTextAreaProps>) {
    const { value, onChange, disabled = false, placeholder, label } = textAreaCommonProps;
    const { popoutInputBaseProps: { inputBasePlaceholder }, popoutInputLabel } = popoutCommonProps;

    const [popoutOpen, setPopoutOpen] = useState(false);
    const [popoutValue, setPopoutValue] = useState('');

    const handleTextAreaFieldChange: ChangeEventHandler<HTMLInputElement> = event => {
        onChange(event.target.value);
    };

    const handleClickOpen = () => {
        setPopoutValue(value);
        setPopoutOpen(true);
    };

    const handleClickClose = (value: string) => {
        setPopoutOpen(false);
        if(!disabled) {
            onChange(value);
        }
    };

    const textAreaPopoutProps: TextAreaPopoutProps = {
        commonPopoutProps: {
            open: popoutOpen,
            value: popoutValue,
            onClose: handleClickClose
        },
        popoutInputLabel: popoutInputLabel,
        popoutInputBaseProps: {
            inputBasePlaceholder: inputBasePlaceholder
        }
    };

    return (
        <Box
            sx={{
                position: 'relative',
                display: 'flex',
                backgroundColor: 'background.paper',
                flexDirection: 'column'
            }}>
            <ExpandableTextField
                multiline={true}
                onChange={handleTextAreaFieldChange}
                maxRows={5}
                sx={{
                    backgroundColor: 'background.paper',
                    borderRadius: '4px'
                }}
                placeholder={placeholder}
                size="small"
                label={label}
                variant="filled"
                value={value}
                disabled={disabled}
            />
            <IconButton
                disabled={disabled}
                onClick={handleClickOpen}
                sx={{
                    position: 'absolute',
                    right: '0px',
                    bottom: '0px',
                    color: 'primary.accent',
                }}
                aria-label="expand-notes">
                <UnfoldMoreIcon
                    sx={{
                        transform: 'rotate(45deg);'
                    }} />
            </IconButton>
            <TextAreaPopout {...textAreaPopoutProps} />
        </Box>
    );
}
